import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/store/auth-store'

const CHANGE_PASSWORD_PATH = '/change-password'

/**
 * Bloqueia a navegação para qualquer rota autenticada além de `/change-password`
 * enquanto `mustChangePassword = true` (RF06).
 *
 * O backend só aceita `POST /admin/auth/change-password` com um access token
 * emitido nesse estado — deixar o front navegar livremente resultaria em 401
 * inesperado na primeira chamada a qualquer outro endpoint. Este guard fica
 * dentro de `ProtectedRoute` (já garante `isAuthenticated`) e antes do
 * `AppLayout`, então cobre todas as rotas autenticadas, incluindo a própria
 * `/change-password`, que segue precisando do `ProtectedRoute` normal.
 */
export function RequirePasswordChangeRoute() {
  const { mustChangePassword } = useAuthStore()
  const location = useLocation()

  if (mustChangePassword && location.pathname !== CHANGE_PASSWORD_PATH) {
    return <Navigate to={CHANGE_PASSWORD_PATH} replace />
  }

  return <Outlet />
}
